export default __webpack_public_path__ + "static/media/BlogSite.9cfa8a46.png";